// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OperationTypeCard_donutWrap__q9V\\+4 {
  position: relative;
  width: 100%;
  height: 170px;
}
.OperationTypeCard_centerLogo__AVSI- {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
}
.OperationTypeCard_centerLogo__AVSI- img {
  width: auto;
  height: 46px;
}

.OperationTypeCard_legendTitle__H7V7X {
  font-size: 14px;
  font-weight: 600;
  color: var(--dylo-ink);
  margin: 18px 0 4px;
  position: relative;
  padding-bottom: 6px;
}
.OperationTypeCard_legendTitle__H7V7X::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 34px;
  height: 2px;
  background: var(--dylo-line);
}

.OperationTypeCard_legendSub__yjanN {
  font-size: 12.5px;
  color: var(--dylo-muted);
  margin: 0 0 12px;
}

.OperationTypeCard_legend__unjaK {
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.OperationTypeCard_legendItem__\\+fn3A {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--dylo-text);
}
.OperationTypeCard_dot__O03CF {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/OperationTypeCard.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".donutWrap {\n  position: relative;\n  width: 100%;\n  height: 170px;\n}\n.centerLogo {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 1;\n}\n.centerLogo img {\n  width: auto;\n  height: 46px;\n}\n\n.legendTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n  margin: 18px 0 4px;\n  position: relative;\n  padding-bottom: 6px;\n}\n.legendTitle::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 34px;\n  height: 2px;\n  background: var(--dylo-line);\n}\n\n.legendSub {\n  font-size: 12.5px;\n  color: var(--dylo-muted);\n  margin: 0 0 12px;\n}\n\n.legend {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n.legendItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--dylo-text);\n}\n.dot {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"donutWrap": `OperationTypeCard_donutWrap__q9V+4`,
	"centerLogo": `OperationTypeCard_centerLogo__AVSI-`,
	"legendTitle": `OperationTypeCard_legendTitle__H7V7X`,
	"legendSub": `OperationTypeCard_legendSub__yjanN`,
	"legend": `OperationTypeCard_legend__unjaK`,
	"legendItem": `OperationTypeCard_legendItem__+fn3A`,
	"dot": `OperationTypeCard_dot__O03CF`
};
export default ___CSS_LOADER_EXPORT___;
